var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustrationInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 311,
    viewBox: "0 0 311 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_3516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.5 311C241.38 311 311 241.38 311 155.5C311 69.6197 241.38 0 155.5 0C69.6197 0 0 69.6197 0 155.5C0 241.38 69.6197 311 155.5 311Z",
    fill: "url(#paint0_linear_1524_3516)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.118,
    cy: 237.118,
    r: 49,
    transform: "rotate(62.4208 226.118 237.118)",
    fill: "url(#paint1_radial_1524_3516)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1524_3516",
    x1: 155.5,
    y1: -78.6634,
    x2: 155.5,
    y2: 404.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2484,
    stopColor: "#0E0A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#100B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    stopColor: "#130D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    stopColor: "#17105D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7067,
    stopColor: "#1C1476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    stopColor: "#1E1581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E15C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1524_3516",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.733 216.387) rotate(38.8534) scale(87.1214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108,
    stopColor: "#3B3FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopColor: "#2D32B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#2C30B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#373EFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_3516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 311,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustrationInfo);
export default __webpack_public_path__ + "static/media/ilustration_info.4415a863bfdaa6094e467e04277d9ac7.svg";
export { ForwardRef as ReactComponent };